export const SHOP_NOW_CTA_LABEL = 'Shop now';
export const SUBSCRIBE_AND_SAVE_CTA_LABEL = 'Subscribe & Save';
export const SIGN_UP_CTA_LABEL = 'Sign up';
